module.exports = __webpack_public_path__ + "static/media/Meepo.f4c8a853.png";